/*
  AESKA cart drawer actions: upsell add, Priority dispatch toggle, quantity nudge.
  Uses event delegation because the drawer body is re-rendered after every cart change.
  After each change it asks the theme to re-render the cart (FoxTheme.storefrontActions.refreshCart),
  so the drawer, the cart count and any app listening to cart updates stay in sync.
*/
(() => {
  if (window.__aeskaCartBound) return;
  window.__aeskaCartBound = true;

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const post = (path, body) =>
    fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(async (response) => {
      const json = await response.json().catch(() => ({}));
      if (!response.ok || json.status) throw new Error(json.description || json.message || 'Cart update failed');
      return json;
    });

  const refresh = async () => {
    if (window.FoxTheme && FoxTheme.storefrontActions && FoxTheme.storefrontActions.refreshCart) {
      await FoxTheme.storefrontActions.refreshCart();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    }
  };

  const busy = (el, on) => {
    if (!el) return;
    if (on) el.setAttribute('aria-busy', 'true');
    else el.removeAttribute('aria-busy');
  };

  document.addEventListener('click', async (event) => {
    const addBtn = event.target.closest('#CartDrawer [data-aeska-up-add]');
    if (addBtn) {
      event.preventDefault();
      const card = addBtn.closest('.aeska-up__card');
      const select = card && card.querySelector('[data-aeska-up-select]');
      const id = Number((select && select.value) || addBtn.dataset.variantId);
      busy(addBtn, true);
      try {
        await post('cart/add.js', { items: [{ id, quantity: 1 }] });
        await refresh();
      } catch (error) {
        console.error(error);
        busy(addBtn, false);
        alert(error.message);
      }
      return;
    }

    const nudge = event.target.closest('#CartDrawer [data-aeska-nudge]');
    if (nudge) {
      event.preventDefault();
      const line = nudge.dataset.aeskaNudge;
      const input = document.querySelector(`#CartDrawer #CartDrawer-Item-${line} .quantity__input`);
      if (!input) return;
      busy(nudge, true);
      input.value = parseInt(input.value, 10) + parseInt(nudge.dataset.add || '1', 10);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', async (event) => {
    const toggle = event.target.closest('#CartDrawer [data-aeska-dispatch]');
    if (!toggle) return;
    const label = toggle.closest('.aeska-dp');
    busy(label, true);
    try {
      if (toggle.checked) {
        await post('cart/add.js', {
          items: [{ id: Number(toggle.dataset.variantId), quantity: 1, properties: { _aeska_dispatch: '1' } }]
        });
      } else if (toggle.dataset.lineKey) {
        await post('cart/change.js', { id: toggle.dataset.lineKey, quantity: 0 });
      }
      await refresh();
    } catch (error) {
      console.error(error);
      toggle.checked = !toggle.checked;
      busy(label, false);
      alert(error.message);
    }
  });

  // The drawer HTML comes with the page and can carry stale discount names (bundle tiers).
  // Re-render it once from the live cart the first time it opens on each page.
  const watchDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    let refreshed = false;
    new MutationObserver(() => {
      if (refreshed || !drawer.open) return;
      refreshed = true;
      refresh().catch((error) => console.error(error));
    }).observe(drawer, { attributes: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();

  // Keep Priority dispatch from being the only thing left in the cart.
  document.addEventListener('cart:updated', async (event) => {
    const cart = event.detail && event.detail.cart;
    const toggle = document.querySelector('#CartDrawer [data-aeska-dispatch]');
    if (!cart || !cart.items || !toggle) return;
    const dispatchId = Number(toggle.dataset.variantId);
    const others = cart.items.filter((item) => item.variant_id !== dispatchId);
    const dispatchLine = cart.items.find((item) => item.variant_id === dispatchId);
    if (others.length === 0 && dispatchLine) {
      try {
        await post('cart/change.js', { id: dispatchLine.key, quantity: 0 });
        await refresh();
      } catch (error) {
        console.error(error);
      }
    }
  });
})();
